module.exports = __webpack_public_path__ + "img/gallery04.d22271e1.jpg";